import { useTranslation } from "react-i18next";
import { ChevronDown, Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SUPPORTED_LANGS, changeLanguage } from "@/i18n";

export default function LanguageSwitcher({ variant = "pill" }) {
  const { i18n } = useTranslation();
  const current = SUPPORTED_LANGS.find((l) => l.code === i18n.language) || SUPPORTED_LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="language-switcher"
          className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs transition-all"
          style={{
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.10)",
            color: "#cfcfcf",
            letterSpacing: "0.06em",
            minWidth: 56,
          }}
          aria-label="Language"
        >
          <Globe size={12} style={{ opacity: 0.7 }} />
          <span style={{ fontWeight: 600 }}>{current.short}</span>
          <ChevronDown size={12} style={{ opacity: 0.7 }} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={6}
        className="min-w-[170px]"
        style={{
          background: "rgba(20,20,20,0.96)",
          border: "1px solid rgba(255,255,255,0.10)",
          color: "#e8e8e8",
          backdropFilter: "blur(8px)",
        }}
      >
        {SUPPORTED_LANGS.map((l) => {
          const active = l.code === i18n.language;
          return (
            <DropdownMenuItem
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onSelect={() => changeLanguage(l.code)}
              className="text-sm cursor-pointer"
              style={{
                color: active ? "#ff5a55" : "#e8e8e8",
                fontWeight: active ? 600 : 400,
              }}
            >
              <span className="w-7 inline-block text-xs" style={{ opacity: 0.7 }}>{l.short}</span>
              <span>{l.native}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
